import ModuleMultiColumnCards from './ModuleMultiColumnCards';

export default ModuleMultiColumnCards;
export * from './ModuleMultiColumnCards';
